<template>
	<div v-if="image" class="landing-background-image" :style="backgroundImageStyle"></div>
</template>

<script>
export default {
	name: 'LandingBackgroundImage',

	props: {
		image: {
			type: [String, null],
			default: null,
		},

		position: {
			type: String,
			default: 'center',
			validator(v) {
				return ['center', 'top'].includes(v)
			},
		},
	},

	computed: {
		backgroundImageStyle() {
			if (!this.image) {
				return {}
			}

			return {
				backgroundImage: `url(${this.image})`,
				// 'top' keyword resolves to "center top" — anchors the hero to the top so the
				// subject's face isn't cropped on short/wide viewports.
				backgroundPosition: this.position,
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.landing-background-image {
	position: fixed;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
	width: 100%;
	max-width: 900px;
	height: 100vh;
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	pointer-events: none;
	z-index: -1;
}
</style>
